const getListItem = (index: number, step: number) => (
    <li className={`step-tab ${index === step ? 'active' : 'disabled'}`} role={'presentation'}>
        {/* biome-ignore lint/a11y/useValidAnchor: suppress out of convenience during migration to biome */}
        {/* biome-ignore lint/a11y/useSemanticElements: suppress out of convenience during migration to biome */}
        <a href={'#'} role={'button'} style={{ pointerEvents: 'none' }} tabIndex={-1}>
            <div className={'item-icon text-center'}>{index}</div>
        </a>
    </li>
);

export const CustomSteppedProgress = ({ step = 1 }: { step: number }) => {
    return step > 3 ? null : (
        <ul className={'stepped-progress-bar nav variant-circle'}>
            {getListItem(1, step)}
            {getListItem(2, step)}
            {getListItem(3, step)}
        </ul>
    );
};
